import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./section.css"

const Section = ({ children, style }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          typeAreaWidth
        }
      }
    }
  `)

  return (
    <section className="section-container">
      <div
        className="section-wrapper"
        style={{ maxWidth: site.siteMetadata.typeAreaWidth, ...style }}
      >
        {children}
      </div>
    </section>
  )
}

export default Section
